import client from './client.js';

export const searchCustomers = (q) =>
  client.get('/customers', { params: { search: q, limit: 20 } }).then((r) => r.data.data);

export const findOrCreateCustomer = ({ name, phone, email }) =>
  client.post('/customers/find-or-create', { name, phone, email }).then((r) => r.data.data);
